export const WALLET = {
  MAIN_WALLET: 'MAIN',
  AGENCY_WALLET: 'SUB'
}

export const DEFAULT_VALUE = {
  MIN: 50,
  MAX: 1000000
}
